import React from "react";
import Flex from "../../../../components/structure/Flex";

interface SectionProps {
  title?: string;
  borderTop?: boolean;
}

const Section: React.FC<SectionProps> = ({ title, children, borderTop }) => {
  return (
    <Flex
      col
      className={borderTop ? "border-t border-theme-surface pt-6 mt-6" : ""}
    >
      {title && (
        <header className="flex items-center justify-between">
          <span className="font-medium text-2xl">{title}</span>
        </header>
      )}
      <section>{children}</section>
    </Flex>
  );
};

export default Section;
